import { render, staticRenderFns } from "./TicketsResend.vue?vue&type=template&id=24b2d651&scoped=true&"
import script from "./TicketsResend.vue?vue&type=script&lang=js&"
export * from "./TicketsResend.vue?vue&type=script&lang=js&"
import style0 from "./TicketsResend.vue?vue&type=style&index=0&id=24b2d651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2d651",
  null
  
)

export default component.exports